<template>
<div id="app" v-loading.fullscreen.lock="!$teras.app.ready" :class="'device-'+$teras.app.device">

  <div class="bg-div yo-bg-cover">&#160;</div>
   
  <sidebar v-on:toggle="$teras.event.emit('sidebarToggle')" >
    <div slot="sidebar" style="color:#fff;width:100%;line-height:2.4rem;font-size:1.6rem;text-align:center;"></div>
  </sidebar>


  <el-popover ref="myLogin"  placement="bottom" width="240" trigger="click">
    <div class="yo-pointer" >Modifica Profilo</div>
    <div class="yo-pointer" v-on:click="$teras.event.emit('logout')">Esci - Logout</div>
  </el-popover>

  <div class="yo-bg-color-primary" style="z-index:1200;position:fixed;height:24px;width:100%;" >
    <div class="row pad-in yo-text-s yo-valign-center" style="height:24px;">
      <div class="col s12 m4 offset-m8 yo-align-right white">
        <mylogin-navbar v-if="$teras.app.auth"></mylogin-navbar>
        <router-link  v-else to="/mylogin" class="white yo-text-n">myLogin</router-link>
      </div>
    </div>
  </div>
  <div style="height:24px;width:100%;">&#160;</div>

   <div class="header-top" >
      <site-header></site-header>
      <!-- <site-navbar v-if="$teras.app.device=='desktop'"></site-navbar> -->
   </div>

   <div class="app-main row">
      <div id="main" class="col s12" >
         <router-view name="main"></router-view>

          <!-- BOTTOM LINK 
          <bottomlink ></bottomlink>
          -->

      </div><!-- end main -->
   </div><!-- end container -->
   
   
   
   <div class="el-footer footer-bottom yo-text-normal yo-bg-color-primary">
      <site-footer v-if="!(['savethedate'].indexOf($route.name) > -1)"></site-footer>
   </div>   
   
   
  <!--
    Il nostro sito web utilizza i cookie per assicurarti la miglior esperienza di navigazione. Se desideri maggiori informazioni sui cookie e su come controllarne l'abilitazione con le impostazioni del browser consulta la nostra Cookie Policy
  -->
  
</div> <!-- end app -->
</template>

<script>
import sidebar from './components/Sidebar'
import siteHeader from './components/Site-header.vue'
import myloginNavbar from './components/Mylogin-navbar.vue'
import siteFooter from './components/Site-footer.vue'
import bottomlink from './components/Bottomlink'

export default {
   name: 'app',
   components: {
      sidebar,
      siteHeader,
      myloginNavbar,
      siteFooter
      ,bottomlink
   },
  metaInfo() {
    return {
      title: this.$teras.page.title,
      //titleTemplate: '%s | My Awesome Webapp',
      meta: [
        { property: 'og:title', content: this.$teras.page.tile },
        //{ name: 'viewport', content: 'width=device-width, initial-scale=1' }
        //,{ 'http-equiv': 'refresh', content: 'https://next.biomedia.net/eventi/evento-home/'+ this.$teras.evento.id}

      ]
    }
  }
}
</script>

<style>
#app{

}
.app-main{
  min-height:100vh;
}
.bg-div{
  background-image: url('./assets/bg.jpg');
  width: 100vw;
  height: 100vh;
  position:fixed;
  top:0;left:0;
  z-index:-1;
}.header-top{
  max-width: 1296px !important;
  margin: auto !important;
  padding: 20px 0;
}.app-main{
  max-width: 1296px !important;
  margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue